import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import {
  GetAllFinacUserPayloadType,
  GetAssignedClientsToUserPayloadType,
} from "../../../commonTypes/authTypes";
import {
  AddDisbursementPayloadType,
  ApprovalPayloadType,
  EditDisbursementPayloadType,
  SingleDisbursementPayloadType,
} from "../../../commonTypes/disbursementsTypes";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import {
  getAllFinacUsersAction,
  getAssignedClientsToUserAction,
} from "../../../redux/auth";
import {
  ClientType,
  FinacUsersType,
  LoginResponseType,
} from "../../../redux/auth/authTypes";
import {
  getSingleDisbursementAction,
  resetApprovalMessage,
} from "../../../redux/disbursements";
import { getJobsListAction, resetJobsList } from "../../../redux/jobs";
import { JobTrackerListingType } from "../../../redux/listing/listingTypes";
import { RootState } from "../../../redux/rootReducers";
import { checkSameUserId } from "../../../utils/commonFunctions";
import {
  downloadLink,
  imagePreview,
} from "../../../utils/invoiceGeneration/commonFunctions";
import ImagePreview from "../../FileManager/Files/ImagePreview";
import { PlusIconCircle } from "../../Icon";
import { Loader, UploadModal } from "../../commons";
import Approve from "../../commons/ApprovalModule/Approve";
import DisbursementInputDetails from "./DisbursementInputDetails";
import DisbursementPaymentDetails from "./DisbursementPaymentDetails";

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};

export type SelctOptionType = {
  value: number | null;
  label: string;
};

export type UserListType = {
  label: string | null | undefined;
  value: number | null | undefined | string;
};

export type InputType = {
  title: string;
  amount: number | null;
  descriptionOfPayment: string;
  modeOfPayment: string;
  receivedAmount: string;
};
type FormErrorType = {
  clientCodeError: string;
  clientJobIdError: string;
  titleError: string;
};
type RadioTypes = {
  id: string;
  name: string;
};

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "No",
  },
  {
    id: "1",
    name: "Yes",
  },
];
export type PaymentDetailsType = {
  amountReceive: number | null;
  modeOfPayment: string | null;
  dateOfPayment: string | null;
  narration: string | null;
};
const paymentDetails: PaymentDetailsType[] = [
  {
    amountReceive: null,
    modeOfPayment: "",
    dateOfPayment: null,
    narration: "",
  },
];

type AppProps = {
  history: any;
  token: string | null;
  date?: string | null;
  recoverDate?: string;
  fetching: boolean;
  tab?: string;
  attachmentValue?: string;
  approvalValue?: string;
  loginData: LoginResponseType;
  clientList: ClientType[] | [];
  jobTrackerListing: [] | JobTrackerListingType[];
  singleDisbursement?: any;
  approvalMessage: string | null;
  finacUsersList: any;
  userFetching: boolean;
  paymentStatus?: string;
  allPaymentStatus?: number[];
  handleDateChange: (data: any) => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  dispatchResetJobTrackerListing: () => void;
  dispatchResetApprovalMessage: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetClientsActiveJobAction: (data: any) => void;
  handleAddDisbursements?: (data: AddDisbursementPayloadType) => void;
  handleEditDisbursement?: (data: EditDisbursementPayloadType) => void;
  dispatchGetSingleDisbursementAction: (
    data: SingleDisbursementPayloadType
  ) => void;
  setDate?: (data: any) => void;
  setRecoverDate?: (data: string) => void;
  handleDisbursementApproval?: (data: ApprovalPayloadType) => void;
};

const AddEditDisbursementForm = ({
  history,
  token,
  loginData,
  clientList,
  finacUsersList,
  userFetching,
  tab,
  dispatchGetAllFinacUsersAction,
  date,
  fetching,
  jobTrackerListing,
  paymentStatus,
  allPaymentStatus,
  handleDateChange,
  recoverDate,
  dispatchGetAssignedClientsToUserAction,
  dispatchResetJobTrackerListing,
  dispatchGetClientsActiveJobAction,
  handleAddDisbursements,
  singleDisbursement,
  handleEditDisbursement,
  setDate,
  setRecoverDate,
  dispatchResetApprovalMessage,
  handleDisbursementApproval,
  attachmentValue,
  approvalValue,
}: AppProps) => {
  const searchData = history?.location?.state?.searchData;
  const defaultTeamMembersString =
    process.env.REACT_APP_DEFAULT_ACCESS_TEAMS_MEMBERS || "[]";
  const defaultTeamMembers: SelctOptionType[] = JSON.parse(
    defaultTeamMembersString
  ) as SelctOptionType[];
  const defaultTeamMembersIds: any[] | [] = defaultTeamMembers
    ?.map((ids) => ids.value)
    ?.slice(0, 3);
  const [finalClientList, setFinalClientList] = useState<
    DropDownItemType[] | []
  >([]);
  const [finalJobList, setFinalJobList] = useState<DropDownItemType[] | []>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState<any>([]);
  const [selectedAccessTeam, setSelectedAccessTeam] = useState<number[] | []>([
    ...defaultTeamMembersIds,
  ]);
  const [jobSelected, setJobSelected] = useState<SelctOptionType>({
    value: null,
    label: "Select Job",
  });
  const [userSelected, setUserSelected] = useState<SelctOptionType[]>(
    defaultTeamMembers?.slice(0, 3)
  );
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });
  const [clientId, setClientId] = useState<any>(null);
  const [radioValue, setRadioValue] = useState(RADIO_OPTIONS[0]?.id);
  const [uploadData, setUploadData] = useState<any[]>([]);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);

  const [approved, setApproved] = useState<boolean>(false);
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setoffset] = useState<number>(0);
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [inputDetails, setInputDetails] = useState<InputType>({
    title: "",
    amount: null,
    descriptionOfPayment: "",
    modeOfPayment: "",
    receivedAmount: "",
  });
  const [formError, setFormError] = useState<FormErrorType>({
    clientCodeError: "",
    clientJobIdError: "",
    titleError: "",
  });
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [paymentDetailsData, setPaymentDetailsData] = useState<any>(
    JSON.parse(JSON.stringify(paymentDetails))
  );
  //====================User Management=============================
  const [isApproveDisbursementPresent, setIsApproveDisbursementPresent] =
    useMenuCheck();

  //=================================================================
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  useEffect(() => {
    setIsApproveDisbursementPresent("Approve Disbursement", "menu");
    dispatchResetJobTrackerListing();
    dispatchResetApprovalMessage();
    const finalData = {
      token,
      user_id: loginData?.user_id,
    };
    dispatchGetAssignedClientsToUserAction(finalData);
  }, []);

  useEffect(() => {
    if (isEdit && singleDisbursement?.shared_with_users?.length == 0) {
      setUserSelected([]);
      setSelectedAccessTeam([]);
    }
  }, [isEdit, singleDisbursement]);

  useEffect(() => {
    if (clientList?.length) {
      let finalClientData = clientList?.map((client: ClientType) => {
        return {
          value: client?.client_code,
          label: `(${client?.client_code})  ${client?.company_name}`,
        };
      });

      setFinalClientList(finalClientData);
    }
  }, [clientList]);

  useEffect(() => {
    if (offset > 0 && offset <= finacUsersList?.total_count) {
      fetchNewData(text);
    }
  }, [offset]);

  useEffect(() => {
    if (finacUsersList?.data?.length) {
      const data = finacUsersList?.data?.filter(
        (e: any) => e?.user_id !== loginData?.user_id
      );
      let finalUserData = data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name} ${user?.last_name}`,
          image: user?.profile_pic?.file_url,
        };
      });

      if (offset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
      } else {
        setFinalUserList([...finalUserData]);
      }
    }
  }, [finacUsersList]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        // setFinacApiCall(true)
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  useEffect(() => {
    if (jobTrackerListing?.length > 0) {
      let finalJobsData = jobTrackerListing?.map((job: any) => {
        return {
          value: job?.job_id,
          label: `${job?.job_type}(${job?.job_id})`,
        };
      });

      setFinalJobList(finalJobsData);
    } else {
      setFinalJobList([]);
    }
  }, [jobTrackerListing]);

  useEffect(() => {
    if (singleDisbursement?.client_code) {
      setIsEdit(true);
      setInputDetails((prev) => ({
        ...prev,
        title: singleDisbursement?.title,
        amount: singleDisbursement?.amount,
        descriptionOfPayment: singleDisbursement?.payment_description,
        modeOfPayment: singleDisbursement?.mode_of_payment,
        receivedAmount: singleDisbursement?.received_amount,
      }));
      setClientSelected({
        value: singleDisbursement?.client_code,
        label: `(${singleDisbursement?.client_code}) ${singleDisbursement?.client_name}`,
      });
      setJobSelected({
        value: singleDisbursement?.client_job_id,
        label: `${singleDisbursement?.job_type}(${singleDisbursement?.client_job_id})`,
      });
      if (singleDisbursement?.client_code && token) {
        dispatchResetJobTrackerListing();
        let finalData = {
          clientCode: singleDisbursement?.client_code,
          token,
          filterStatus: "Open",
        };
        dispatchGetClientsActiveJobAction(finalData);
      }
      if (singleDisbursement?.attachment) {
        setUploadData(singleDisbursement?.attachment);
      }
      setRadioValue(singleDisbursement?.is_amount_recovered?.toString());
      setDate?.(singleDisbursement?.payment_date);
      setRecoverDate?.(singleDisbursement?.recovery_date);
      if (singleDisbursement?.client_received_details?.length) {
        let arr: any[] = [];
        singleDisbursement?.client_received_details?.map((item: any) => {
          arr.push({
            amountReceive: item?.amount_received,
            modeOfPayment: item?.mode_of_payment,
            dateOfPayment: item?.date_of_payment,
            narration: item?.narration,
          });
        });
        setPaymentDetailsData(arr);
      }
      if (singleDisbursement?.shared_with_users?.length > 0) {
        const editSelecteAccessTeam = singleDisbursement?.shared_with_users
          ?.filter((e: any) => e?.user_id !== loginData?.user_id)
          ?.filter((e: any) => e?.is_client !== 1);

        let totalUser = editSelecteAccessTeam?.map((e: any) => {
          return {
            value: e?.user_id,
            label: e?.name,
          };
        });
        const accessTeamMembersId = editSelecteAccessTeam?.map(
          (e: any) => e?.user_id
        );

        setUserSelected(totalUser);
        setSelectedAccessTeam(accessTeamMembersId);
      }
      if (singleDisbursement?.approval_details?.length) {
        let user_id;
        if (loginData?.user_id) {
          user_id = checkSameUserId(
            loginData?.user_id,
            singleDisbursement?.approval_details
          );
        }
        let totelArrpovedData =
          singleDisbursement?.approval_details?.length === 3;
        setApproved(user_id || totelArrpovedData);
      }
    }
  }, [singleDisbursement]);

  const handleChangeJob = (job: any) => {
    setJobSelected(job);

    if (jobTrackerListing && jobTrackerListing?.length) {
      jobTrackerListing?.map((item: any) => {
        if (item.job_id === job.value) {
          setSelectedJobDetails(item);
        }
      });
    }
  };

  const handleChangeClient = (client: any) => {
    if (client !== clientSelected) {
      setJobSelected({
        value: null,
        label: "Select Job...",
      });
    }
    setClientId(client.value);
    setClientSelected(client);
    if (client && token) {
      dispatchResetJobTrackerListing();
      let finalData = {
        clientCode: client.value,
        token,
        filterStatus: "Open",
      };
      dispatchGetClientsActiveJobAction(finalData);
    }
  };
  //Upload files
  const renderFilesList = () => {
    const isDelete = true;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        let file_type = data.file_url.split(".");
        return file_type[file_type.length - 1].toLowerCase() === "png" ||
          file_type[file_type.length - 1].toLowerCase() === "jpg" ||
          file_type[file_type.length - 1].toLowerCase() === "jpeg" ||
          file_type[file_type.length - 1].toLowerCase() === "doc" ||
          file_type[file_type.length - 1].toLowerCase() === "docx" ||
          file_type[file_type.length - 1].toLowerCase() === "xls" ||
          file_type[file_type.length - 1].toLowerCase() === "ppt" ||
          file_type[file_type.length - 1].toLowerCase() === "pptx" ||
          file_type[file_type.length - 1].toLowerCase() === "xlsx" ||
          file_type[file_type.length - 1].toLowerCase() === "pdf"
          ? imagePreview(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            )
          : downloadLink(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            );
      });

    return finalFileList;
  };

  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };
  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(uploadData));

    const isFilePresent = tempFileData?.find((data: any, idx: number) => {
      return idx === index;
    });

    if (!!isFilePresent) {
      let newData = tempFileData?.filter(
        (data: any, idx: number) => idx !== index
      );
      setUploadData(newData);
    }
  };

  const handleUploadFile = (data: any) => {
    if (!uploadData) {
      setUploadData([data]);
    }
    setShowFileUploadModal(false);
    let oldFileUploadData = [...uploadData];
    oldFileUploadData.push(data);
    setUploadData(oldFileUploadData);
  };

  const handleToggleFileUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  };

  const handleInputDetailsChange = (e: any) => {
    const Name = e.target.name;
    setFormError((prev: any) => ({
      ...prev,
      ...(inputDetails?.title && Name === "title" && { titleError: "" }),
    }));
    setInputDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePaymentDetailsChange = (
    dataKey: any,
    value: any,
    index: number
  ) => {
    let temp = JSON.parse(JSON.stringify(paymentDetailsData));
    if (value === "Invalid date") {
      temp[index][dataKey] = "";
    } else {
      temp[index][dataKey] = value;
    }
    setPaymentDetailsData([...temp]);
  };

  const handleAddAnotherPaymentDetails = () => {
    let temp: any = JSON.parse(JSON.stringify(paymentDetailsData));
    temp.push(...JSON.parse(JSON.stringify(paymentDetails)));
    setPaymentDetailsData(temp);
  };

  const handleRemoveRow = (index: any) => {
    let temp = JSON.parse(JSON.stringify(paymentDetailsData));
    temp.splice(index, 1);
    setPaymentDetailsData(temp);
  };
  //Submit Form
  const handleSubmitForm = () => {
    let shared_with = tab === "shared_with_me" ? 1 : "";
    if (
      inputDetails?.title?.trim() &&
      clientSelected?.value &&
      jobSelected?.value
    ) {
      const finalData = {
        ...inputDetails,
        date,
        recoverDate,
        clientId: clientSelected?.value,
        jobSelected: jobSelected
          ? jobSelected
          : { value: null, label: "Select Job..." },
        isRecovered: radioValue,
        uploadData,
        paymentDetails: paymentDetailsData,
        accessMemberIds:
          tab === "shared_with_me"
            ? loginData && loginData?.user_id
              ? [...selectedAccessTeam, loginData?.user_id]
              : [...selectedAccessTeam]
            : selectedAccessTeam,
        ...(shared_with && { shared_with }),
      };

      if (singleDisbursement?.client_code) {
        const data = {
          ...finalData,
          disbursementId: singleDisbursement?.disbursement_id,
        };
        handleEditDisbursement?.(data);
      } else {
        handleAddDisbursements?.(finalData);
      }
    } else {
      setFormError((prev: any) => ({
        ...prev,
        ...(!inputDetails?.title?.trim() && { titleError: "Title required" }),
        ...(!clientSelected?.value && { clientCodeError: "Choose client..." }),
        ...(!jobSelected?.value && { clientJobIdError: "Choose job type..." }),
      }));
    }
  };

  const handleChange = (e: any) => {
    let accessTeamIdName: any = e?.map((e: any) => {
      return e?.value;
    });

    let totalUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setUserSelected(totalUser);
    setSelectedAccessTeam(accessTeamIdName);
  };

  const handleApproval = () => {
    if (singleDisbursement?.disbursement_id && token) {
      const finalData = {
        token,
        disbursementId: singleDisbursement?.disbursement_id,
      };
      handleDisbursementApproval?.(finalData);
    }
  };

  return (
    <>
      <DisbursementInputDetails
        date={date}
        isEdit={isEdit}
        inputDetails={inputDetails}
        finalClientList={finalClientList}
        clientSelected={clientSelected}
        finalJobList={finalJobList}
        jobSelected={jobSelected}
        uploadData={uploadData}
        handleDateChange={handleDateChange}
        handleChangeClient={handleChangeClient}
        handleChangeJob={handleChangeJob}
        handleInputDetailsChange={handleInputDetailsChange}
        handleToggleFileUploadModal={handleToggleFileUploadModal}
        showPopUpContentModal={showPopUpContentModal}
        setShowPopUpContentModal={setShowPopUpContentModal}
        renderFilesList={renderFilesList}
        formError={formError}
        finalUserList={finalUserList}
        userSelected={userSelected}
        handleChange={handleChange}
        userFetching={userFetching}
        setText={setText}
        setOffset={setoffset}
        limit={limit}
      />
      <div className="row">
        <div className="col-md-6 mt-3">
          <h5>Amount Recovered</h5>
        </div>
      </div>
      <DisbursementPaymentDetails
        paymentDetailsData={paymentDetailsData}
        handlePaymentDetailsChange={handlePaymentDetailsChange}
        handleRemoveRow={handleRemoveRow}
      />
      <div className="row">
        <div className="col-md-12 mb-3 mt-3">
          <button
            className="btn btn-outline"
            onClick={handleAddAnotherPaymentDetails}
          >
            <span>
              <PlusIconCircle /> Add More
            </span>
          </button>
        </div>
      </div>

      {singleDisbursement?.client_code && isApproveDisbursementPresent && (
        <Approve
          handleApproval={handleApproval}
          isApprove={true}
          approved={approved}
          approvalDetails={singleDisbursement?.approval_details}
        />
      )}
      <hr></hr>
      <div className="row mt-3">
        <div className="col-md-12 text-right">
          <button
            className="btn"
            style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
            onClick={() => {
              history?.push({
                pathname: `/disbursement-module`,
                state: {
                  tab,
                  approvalValue,
                  attachmentValue,
                  searchData,
                  paymentStatus,
                  allPaymentStatus,
                },
              });
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              handleSubmitForm();
            }}
            disabled={
              !clientSelected?.value ||
              !inputDetails?.title ||
              !jobSelected?.value
            }
          >
            {singleDisbursement?.client_code ? "Update Details" : "Add Details"}
          </button>
        </div>
      </div>
      {fetching && <Loader />}
      {imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
        />
      )}
      {showFileUploadModal && (
        <UploadModal
          modal={showFileUploadModal}
          toggleModal={handleToggleFileUploadModal}
          client_code={clientSelected?.value}
          token={token}
          handleUploadFile={handleUploadFile}
          isDraggableModal
          acceptedFiles="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, 
          application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
          supportedFiles="images, PDF, excel , ppt , pptx and doc."
        />
      )}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.auth.assignedClientsToUserList,
  loginData: state.auth.loginData,
  jobTrackerListing: state.jobs.jobsList,
  approvalMessage: state.disbursements.approvalMessage,
  fetching: state.disbursements.fetching,
  finacUsersList: state.auth.finacUsersList,
  userFetching: state.auth.fetching,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetClientsActiveJobAction: (data: any) =>
    dispatch(getJobsListAction(data)),
  dispatchResetJobTrackerListing: () => dispatch(resetJobsList()),
  dispatchResetApprovalMessage: () => dispatch(resetApprovalMessage()),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetSingleDisbursementAction: (data: SingleDisbursementPayloadType) =>
    dispatch(getSingleDisbursementAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditDisbursementForm);
